/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".product-image[_ngcontent-%COMP%] {\n  max-width: 200px;\n  max-height: 200px;\n}\n\n.active[_ngcontent-%COMP%] {\n  border-color: var(--success);\n}\n\ntextarea[_ngcontent-%COMP%] {\n  width: 100%;\n}"];
export { styles as styles };
